import React from "react";

export default function ContactPage() {
  return (
    <>
    <div className="tool-content">
        <h2>Contact</h2>
        <div className="tool-content-about-page">
        <p>
        For questions or feedback, please contact:
        </p>

        <p>
        support@flyavicalc.com
        </p>
        </div>
            </div>
            </>
  );
}